export default __webpack_public_path__ + "static/site-logo-939986d2a361e65312f05f3ab586dc3a.png";